module.exports = require("@swa-ui/core/src/PositionIndicator/PositionIndicator.module.scss");